import { httpDelete, httpGet_New, httpGetFile, httpPost_New } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { EmptyResult } from '../types/EmptyResult';
import { CreateExportRequest, ExportJob } from '../types/Exports';

// Create Export
const createExport = async (payload: CreateExportRequest): Promise<ExportJob> => await httpPost_New<ExportJob>('api/export', payload);

// Get Exports
const getExports = async (request: PaginatedRequest): Promise<PaginatedResult<ExportJob>> =>
  await httpGet_New<PaginatedResult<ExportJob>>('api/export', request);

// Download Export
const downloadExport = async (id: string, fileName?: string): Promise<void> => await httpGetFile(`api/export/${id}/download`, undefined, fileName);

// Delete Export
const deleteExport = async (id: string): Promise<EmptyResult> => await httpDelete<EmptyResult>(`api/export/${id}`);

// Send Export Email
const sendExportEmail = async (id: string): Promise<EmptyResult> => await httpPost_New<EmptyResult>(`api/export/${id}/send-email`, {});

export { createExport, getExports, downloadExport, deleteExport, sendExportEmail };
